// eslint-disable-next-line import/prefer-default-export
export const amountAPISymbols = ["〇", "△", "✖", "-"] as const; // APIレスポンスで返ってくる仕入先の数量を表す記号
export const amountSymbols = ["○", "△", "×"] as const; // 仕入先の数量を表す記号
export const amountHiddenSymbols = ["○", "△", "×", "-"] as const; // 仕入先の数量を表す記号
export const amountSymbolsWithBlank = ["　", "○", "△", "×"] as const; // 仕入先の数量を表す記号
export const amountSymbolsWithNoStock = ["　", "○", "△", "×", "-"] as const; // 仕入先の数量を表す記号
export const storehouseSupplierOptions = ["倉庫", "仕入先"] as const; // 倉庫、仕入先の選択肢として使用する
export const categories = ["tyre_wheel", "general"] as const;
export const labelCategories = ["タイヤ・ホイール", "一般商品"] as const;
export const stockVisibleTypeLabel = ["数量表示", "記号表示", "非表示"] as const;
export const supplierHeaderColor = "var(--orange-400)";
export const supplierBackgroundColor = "var(--beige-100)";
export const headerColor = "var(--gold-400)"; // #e9e9e9
export const tyreWheelClasses = ["XX", "02", "03"];
export const INT_MAX = 2 ** 31 - 1; // MySQL int型マックス値(マイナスも可の場合)
export const prefectures = [
  "全選択",
  "北海道",
  "青森県",
  "岩手県",
  "宮城県",
  "秋田県",
  "山形県",
  "福島県",
  "茨城県",
  "栃木県",
  "群馬県",
  "埼玉県",
  "千葉県",
  "東京都",
  "神奈川県",
  "新潟県",
  "富山県",
  "石川県",
  "福井県",
  "山梨県",
  "長野県",
  "岐阜県",
  "静岡県",
  "愛知県",
  "三重県",
  "滋賀県",
  "京都府",
  "大阪府",
  "兵庫県",
  "奈良県",
  "和歌山県",
  "鳥取県",
  "島根県",
  "岡山県",
  "広島県",
  "山口県",
  "徳島県",
  "香川県",
  "愛媛県",
  "高知県",
  "福岡県",
  "佐賀県",
  "長崎県",
  "熊本県",
  "大分県",
  "宮崎県",
  "鹿児島県",
  "沖縄県",
];
